import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Message as ChatMessage } from "@/types/assistantChat"
import React from "react"
import { MessageRenderer } from "./MessageRenderer"
import { extractStreamingMessageCitations } from "./utils/chatUtils"

interface StreamingMessageProps {
  message: ChatMessage
}

export const StreamingMessage: React.FC<StreamingMessageProps> = ({
  message,
}) => {
  const { translate } = useTranslation()
  const citations = extractStreamingMessageCitations(
    message,
    translate("AI_CHAT/UNKNOWN_SOURCE"),
  )
  const isReasoningStreaming =
    message.reasoning !== undefined && !message.content

  return (
    <MessageRenderer
      role="assistant"
      content={message.content}
      blocks={message.blocks}
      reasoning={message.reasoning}
      reasoningDuration={message.reasoningDuration}
      isReasoningStreaming={isReasoningStreaming}
      citations={citations}
      showLoading={true}
      sourceMetadata={message.sourceMetadata}
    />
  )
}
